import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SampleSubHeaderComponent } from './sample-sub-header.component';

@NgModule({
  declarations: [SampleSubHeaderComponent],
  imports: [CommonModule],
  exports: [SampleSubHeaderComponent],
})
export class SampleSubHeaderModule {}
